import { zodResolver } from '@hookform/resolvers/zod'
import _ from 'lodash'
import { useForm, FormProvider } from 'react-hook-form'



import { env } from '@/env'
import { Button } from '@/shared/ui'
import { FormControl } from '@/shared/ui/Form/FormControl'
import { FormGroup } from '@/shared/ui/Form/FormGroup'



import { useAuthContext } from '../model/auth-context'
import { resendConfirmationSchema } from '../model/schemas'

const isDev = env.NODE_ENV === 'development'

export const ResendConfirmationForm = () => {
  const {
    isLoading,
    styleConfig,
    config,
    onRequestConfirmationToken,
    goToSignIn
  } = useAuthContext()
  const methods = useForm({
    defaultValues: isDev ? { email: 'wendell@tootz.com.br' } : {},
    resolver: zodResolver(resendConfirmationSchema)
  })

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onRequestConfirmationToken)}>
          <FormGroup
            label="E-mail"
            labelClassName="font-bold"
            name="email"
            size={styleConfig.size}
            solid={styleConfig.solid ? true : undefined}
            control={FormControl}
            type="email"
            vertical
          />
          <div className="mb-5 flex items-center justify-center gap-6">
            <Button
              type="submit"
              variant="primary"
              className="grow"
              loading={isLoading}
              showTrailingIcon={false}
            >
              {isLoading ? 'Solicitando...' : 'Solicitar'}
            </Button>
          </div>
        </form>
      </FormProvider>
    </>
  )
}
